import { useCallback } from 'react';
import { PosSelect, PosSelectProps } from 'src/core/POS/PosSelect';
import { BuyerWithSalesDto } from 'src/WebApiController';

import {
  useRetailBuyerSelector,
  UseRetailBuyerSelectorOptions,
} from './useRetailBuyerSelector';

export const RetailBuyerSelector = ({
  disabled,
  additionalOptions,
  additionalOptionsPosition,
  placeholderText,
  onBuyerSelected,
  ...props
}: Omit<PosSelectProps, 'valueOptionsContent' | 'onChange'> &
  UseRetailBuyerSelectorOptions & {
    onBuyerSelected: (buyer?: BuyerWithSalesDto) => void;
  }) => {
  const {
    query: { isLoading, data },
    posSelectProps,
  } = useRetailBuyerSelector({
    disabled,
    additionalOptions,
    additionalOptionsPosition,
    placeholderText,
  });

  const onSelect = useCallback(
    (value: string) => {
      if (value === 'AddNewBuyer') {
        onBuyerSelected(undefined);
      } else {
        const selectedBuyer = data?.find((b) => b.buyerEmail === value);
        onBuyerSelected(selectedBuyer);
      }
    },
    [data, onBuyerSelected]
  );

  return (
    <PosSelect
      {...props}
      loading={isLoading}
      disabled={disabled}
      allowSearchAsInput
      onChange={onSelect}
      {...posSelectProps}
    />
  );
};
